/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-10-12 15:45:29
 * @LastEditors: MAAS maas@sunengineering.cn
 * @LastEditTime: 2026-10-08 11:25:12
 * @FilePath: \thatOpenTools\src\components\IfcViewer\components\Viewer.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

import {
  forwardRef,
  useContext,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { CloseSquareOutlined } from "@ant-design/icons";
import { pageText } from "../ComponentContext";
import BottomPanel from "./BottomPanel";
import { Button, Empty, Spin, Tabs, TabsProps } from "antd";
import styles from "../index.module.css";
import { initial } from "./ifcLibrary";
import {  clipperModel, postRendererOn, modelsListOn, propertiesOn, classificationsOn, relationsOn, } from "./ifcLibrary";

const Viewer = ({}, ref: any) => {
  const {
    isInit,
    setIsInit,
    loading,
    setLoading,
    leftActive,
    setLeftActive,
    rightActive,
    setRightActive,    
    leftActiveKey,
    rightActiveKey,
    setLeftActiveKey,    
    setRightActiveKey,
  } = useContext(pageText);

  const toolsRef = useRef<any>(null);
  const bottomPanelRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    initial,
    ...bottomPanelRef.current,
  }));

  useEffect(() => {
    // 打开即初始化
    const option = {
      showClickFocus: false, // 点击摄像机聚焦到模型
      showMousePoint: false, // 显示鼠标位置
      showHeightLight: false, // 点击显示高度光
      showRelationTree: true, // 显示关系树
    };
    initial();
    // bottomPanelRef.current?.loadStreamer();
    bottomPanelRef.current?.loadTestIfc();
  }, []);

  // 点击tab
  const clickLeftTabs = async (v: string) => {
    if (v === "modelList") await modelsListOn();
    if (v === "relationTree") await relationsOn();
    if (v === "classificationsTree") await classificationsOn();
    setLeftActiveKey(v);
  }
  const clickRightTabs = async (v: string) => {
    if (v === "propertySet") await propertiesOn();
    if (v === "renderSet") await postRendererOn();
    if (v === "clipperSet") await clipperModel()
    setRightActiveKey(v);
  } 

  // 左侧tabs
  const leftItems:TabsProps['items']  = [
    { label: "模型列表", children: <div id="modelList"><Empty description="暂无数据" /></div>, key: "modelList" , forceRender: true}, 
    { label: "关系类树", children: <div id="relationTree" ><Empty description="暂无数据" /></div>, key: "relationTree" , forceRender: true},
    { label: "构件分类", children: <div id="classificationsTree" ><Empty description="暂无数据" /></div>, key: "classificationsTree", forceRender: true }
  ];
 // 右侧tabs
 const rightItems:TabsProps['items']  = [
  { label: "属性", children: <div id="propertySet"><Empty description="暂无数据" /></div>, key: "propertySet", forceRender: true }, 
  { label: "后期", children: <div id="renderSet" ><Empty description="暂无数据" /></div>, key: "renderSet", forceRender: true},
  { label: "裁剪", children: <div id="clipperSet" ><Empty description="暂无数据" /></div>, key: "clipperSet", forceRender: true }
];


  return (
    <div className={styles.container3D} id="su-bim-viewer">
      {loading && (
        <div className={styles.loading3D} id="loading">
          <Spin tip="加载中..." />
        </div>
      )}
      {/* <bim-viewport className={styles.worldContainer3D} id="bim-viewport" /> */}
      <div
        className={styles.leftPanel3D}
        style={{ display: leftActive ? "block" : "none" }}
        id="left-tools"
      >
         <Button
          type="link"
          onClick={() => {
            setLeftActive(false);
          }}
          className={styles.closeBtn}
          icon={<CloseSquareOutlined />}
        />
        <Tabs defaultActiveKey="1" activeKey={leftActiveKey} items={leftItems} onTabClick={clickLeftTabs} />
        </div>
      <div
        className={styles.rightPanel3D}
        style={{ display: rightActive ? "block" : "none" }}
        id="right-tools"
      >
        <Button
          type="link"
          onClick={() => {
            setRightActive(false);
          }}
          className={styles.closeBtn}
          icon={<CloseSquareOutlined />}
        />
        <Tabs defaultActiveKey="propertySet" activeKey={rightActiveKey} items={rightItems} onTabClick={clickRightTabs} />
      </div>
      <div className={styles.miniMap3D} id="minimap" />
      <BottomPanel ref={bottomPanelRef} />
    </div>
  );
};

export default forwardRef(Viewer);
